<template>
    <div class="map_fiche" id="map">
        <l-map :zoom="zoom" :center="center" ref="myMap" @ready="doSomethingOnReady()">
            <l-tile-layer :url="'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'"
                :attribution="'OpenStreetMap contributors'" />
            <l-marker @click="goToFiche(marker)" v-for="marker in markers" :key="marker.id + '_' + marker.marker"
                :lat-lng="getLatLng(marker.lat, marker.lon)" :icon="getIcon(marker)">
                <l-popup>
                    <b>{{ marker.prenom }} {{ marker.nom }}</b> <br>
                    {{ marker.adresse_marqueur }} <br>
                    <b>Début:</b> {{ marker.date_deb }} <b>Fin:</b> {{ marker.date_fin }}
                </l-popup>
            </l-marker>
        </l-map>
    </div>
</template>

<script>
import Vuex from "vuex";
import router from "../router/index.js";
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-geocoder-ban/dist/leaflet-geocoder-ban.min.css";
import "leaflet-geocoder-ban/dist/leaflet-geocoder-ban.js";

export default {
    name: "Map",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },
    data() {
        return {
            zoom: 18,
            center: L.latLng(window.coords[0], window.coords[1]),
            address: null,
            markers: this.demandesMap
        };
    },
    computed: {
        ...Vuex.mapGetters('Demande', ['currentDemande', 'demandesMap']),
        ...Vuex.mapGetters('Authentification', ['userConnected']),
        ...Vuex.mapGetters('Environnement', ['envModer', 'envAssign'])
    },
    methods: {
        getLatLng(lat, lng) {
            return L.latLng(lat, lng);
        },
        getIcon(marker) {
            if (marker.lat === this.currentDemande.lat && marker.lon === this.currentDemande.lon) {
                return L.icon({
                    iconUrl: require('../assets/marker_odp_default-0.png'),
                    iconSize: [40, 45],
                    iconAnchor: [20, 45]
                })
            }
            else
                return L.icon({
                    iconUrl: require('../assets/marker_' + marker.marker + '-0.png'),
                    iconSize: [40, 45],
                    iconAnchor: [20, 45]
                })
        },
        goToFiche(marker) {
            if (marker.lat === this.currentDemande.lat && marker.lon === this.currentDemande.lon)
                this.$bvModal.show('modal_detail')
        },
        doSomethingOnReady() {
            this.map = this.$refs.myMap.mapObject;
        },
        ...Vuex.mapActions('Demande', ['getDemandes', 'getDemande', 'getDemandeByUniqueId', 'getDemandeToModer'])
    },
    async mounted() {
        if (!!this.$route.params.id) {
            if (this.$route.name === 'ficheModer')
                await this.getDemandeToModer({
                    userId: this.userConnected.userId,
                    dossier: JSON.parse(localStorage['env_moder']).dos_cod_t,
                    idDossier: this.$route.params.id,
                    layername: this.$route.params.layername
                });
            else {
                let params = this.$route.params;
                params.dossier = JSON.parse(localStorage['env_assign']).dos_cod_t;
                await this.getDemande(params);
            }

            this.center = L.latLng(this.currentDemande.lat, this.currentDemande.lon);

            if (this.$route.name == 'ficheModer')
                await this.getDemandes({ df: this.currentDemande.date_fin, dd: this.currentDemande.date_deb, dossier: JSON.parse(localStorage['env_moder']).dos_cod_t });
            else
                await this.getDemandes({ df: this.currentDemande.date_fin, dd: this.currentDemande.date_deb, dossier: JSON.parse(localStorage['env_assign']).dos_cod_t });
            this.markers = this.demandesMap;
        }
        else if (!!this.$route.params.unique_id) {
            await this.getDemandeByUniqueId({ unique_id: this.$route.params.unique_id, dossier: '64483' });
            this.center = L.latLng(this.currentDemande.lat, this.currentDemande.lon);

            this.markers = [];
            this.markers.push(this.currentDemande);
        }
    }
};
</script>

<style></style>
